import { type ReactNode } from 'react';
import { X } from '@hungryroot/icons';
import { BaseModal, IconButton } from '@hungryroot/ramen';
import styles from './LegacyPdpRdpModal.module.css';

type Props = {
  testid?: string;
  children: ReactNode;
  onClose: () => void;
  visible: boolean;
  ariaLabel: string;
};

export function LegacyPdpRdpModal({
  testid,
  children,
  onClose,
  visible,
  ariaLabel,
}: Props) {
  const renderContent = () => (
    <>
      <IconButton
        testid={`${testid}-close`}
        ariaLabel="Close"
        className={styles.close}
        size="small"
        style="inverted"
        prominence="primary"
        onClick={onClose}
        icon={
          <div className={styles['close-container']}>
            <X />
          </div>
        }
      />
      <div className={styles.body}>{children}</div>
    </>
  );

  return (
    <span data-testid={testid} className="rdp-modal-component">
      <BaseModal
        overlayClassName={styles.underlay}
        contentClassName={styles.content}
        ariaLabel={ariaLabel}
        innerContentClassName={styles.container}
        isOpen={visible}
        onDismiss={onClose}
      >
        {renderContent()}
      </BaseModal>
    </span>
  );
}
